import React, { useEffect, useState } from 'react';
import './Notification.css';

const Notification = ({ message, show, duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
    if (show) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration]);

  const handleClose = () => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={`notification ${visible ? 'show' : ''}`}>
      {message}
    </div>
  );
};

export default Notification;
